import _ from "lodash";
import moment from "moment";
import React from "react";

import toastr from "toastr";

export function notifyPopup(text, timeout) {
  toastr.success(text, "", {
    timeOut: timeout || 5000,
    preventDuplicates: true,
  });
}

export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function getTimeReference() {
  return moment.utc({ hour: 0 }).valueOf();
}

export function isMomentWithin(entity, prefix, referenceTime) {
  const ab = entity[prefix ? prefix + "_gueltigab" : "gueltigab"];
  const bis = entity[prefix ? prefix + "_gueltigbis" : "gueltigbis"];
  return ab && new Date(ab).getTime() <= referenceTime
        && (!bis || new Date(bis).getTime() >= referenceTime);
}


export function groupInto(coll, selector) {
  const r = {};
  if (coll) {
    for (const e of coll) {
      const keys = selector(e);
      for (const k of keys) {
        (r[k] || (r[k] = [])).push(e);
      }
    }
  }
  return r;
}

export function groupByMultiple(collection, ...iteratees) {
    /*
     * Creates the following sequence of operations:
     * var step1 = _.groupBy(collection, it1);
     * var step2 = _.mapValues(step1, x => _.groupBy(x, it2));
     * var step3 = _.mapValues(step2, x => _.mapValues(x, y => _.groupBy(y, it3)));
     * var step4 = _.mapValues(step3, x => _.mapValues(x, y => _.mapValues(y, z => _.groupBy(z, it4))));
     */

  let result = collection;
  let grouping = (collection, it) => _.groupBy(collection, it);
  for (const it of iteratees) {
    result = grouping(result, it);
    const innerGrouping = grouping;
    grouping = (collection, it) => _.mapValues(collection, x => innerGrouping(x, it));
  }

  return result;
}

export function ellipsis(text, maxlength, trailer = " ...", firstLine = false) {
  if (firstLine && text.indexOf("\n") >= 0) {
        // nach erstem Newline trennen
    const newlinePos = text.indexOf("\n");
    if (newlinePos >= 0) {
      return text.substring(0, newlinePos);
    }
  } else if (text.length > maxlength) {
    for (let i = maxlength - trailer.length; i > 0; --i) {
      if (text[i] === " ") {
        return text.substring(0, i) + trailer;
      }
    }
    return text.substring(0, maxlength - trailer.length) + trailer;
  }
  return text;
}

export function updateOrPush(list, item, searchPredicate) {
  const index = _.findIndex(list, searchPredicate);
  if (index === -1) {
    list.push(item);
  } else {
    list[index] = item;
  }
}

export function isReactElement(node) {
  return node && !!node.props;
}

export function getInnerText(e, formatPrimitive) {
  return _.flattenDeep(React.Children.map(e.props.children, c => {
    if (isReactElement(c)) {
      return getInnerText(c, formatPrimitive);
    } else if (_.isString(c) || _.isNumber(c)) {
      return formatPrimitive ? formatPrimitive(c) : c;
    }
    return c;
  })).join("");
}

export function sortReactStrings(strings, selector) {
  const padNum = c => _.isNumber(c) ? _.padStart(c.toString(), 10, "0") : c;

  return _.sortBy(strings, e => getInnerText(selector ? selector(e) : e, padNum));
}

export function cls(parts, ...args) {
  return _.flatten(_.map(parts, (p, i) => {
    const pieces = p.split(" ").map(s => _.trim(s)).filter(_.identity);
    const l = pieces.length;
    if (!l) {
      return [];
    }
    pieces[l - 1] = pieces[l - 1].replace(":", "");
    return i >= args.length || args[i] ? pieces : pieces.slice(0, l - 1);
  })).join(" ");
}

const openWindows = {};
export function openWindow(title, body, name = "PopupWindow") {
  let theWindow = openWindows[name];
  if (!theWindow || theWindow.closed) {
    openWindows[name] = window.open("", name, `toolbar=no, location=no, directories=no, status=no,
        menubar=no, scrollbars=yes, resizable=yes, width=780, height=500, top=200, left=${ screen.width - 840 }`);
    theWindow = openWindows[name];
    theWindow.document.write(`
<!DOCTYPE html>
<html>
  <head>
    <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1">
    <meta charset="utf-8">
    <title></title>
    <link rel="stylesheet" href="/vendor-sass.css">
  </head>
  <body style="padding: 0.5em;">
  </body>
</html>
`);
  } else {
    window.blur();
    theWindow.focus();
  }
  theWindow.document.title = title;
  theWindow.document.body.innerHTML = body;
}

export function trimStart(str, characters) {
  let s = 0;
  while (s < str.length && characters.indexOf(str[s]) !== -1) {
    s++;
  }
  return s > 0 ? str.substr(s) : str;
}

export function floorCents(moneyValue) {
  return Math.floor(moneyValue * 100) / 100;
}

export function roundPips(moneyValue) {
  return Math.floor(moneyValue * 10000) / 10000;
}

function regexEscape(str) {
  return str.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
}

// flags: any combination of 'g', 'i', and 'm'
export function regExp(input, flags) {
  return new RegExp(regexEscape(input), flags);
}
